import React from 'react';
import { LinkTitle } from './MainNavigationEnums';
import NewTaskIcon from '../../assets/icons/NewTaskIcon';
import NewToDoIcon from '../../assets/icons/NewToDoIcon';
import NewMessageIcon from '../../assets/icons/NewMessageIcon';
import NewChargeIcon from '../../assets/icons/NewChargeIcon';
import NewClientIcon from '../../assets/icons/NewClientIcon';
import NewFutureIcon from '../../assets/icons/NewFutureIcon';
import PaymentTaskIcon from '../../assets/icons/PaymentTaskIcon';
import NewInvoiceIcon from '../../assets/icons/NewInvoiceIcon';
import NewPaymentIcon from '../../assets/icons/NewPaymentIcon';
import NotImplemented from '../../pages/NotImplemented/NotImplemented';
import {
  EditClientBaseUrl,
  EditTemplateBaseUrl,
  EditTaskBaseUrl,
} from './MainNavigationProps';
import { CreateNewTemplateUrl } from '../../pages/TemplateCenter/CreateNewTemplate/NewTemplateProps';

const CreateNewClient = React.lazy(
  () => import('../../pages/CreateNewClient/CreateNewClient')
);
const AllLists = React.lazy(() => import('../../pages/AllLists/AllLists'));

const editClientLoader = () => import('../../pages/EditClient/EditClient');
export const preloadEditClient = () => editClientLoader();
const EditClient = React.lazy(editClientLoader);
const editTaskLoader = () => import('../../pages/EditTask/EditTask');
export const preloadEditTask = () => editTaskLoader();
const EditTask = React.lazy(editTaskLoader);
const EditTemplate = React.lazy(
  () => import('../../pages/EditTemplate/EditTemplate')
);
const HomePage = React.lazy(() => import('../../pages/HomePage/HomePage'));
const RolesAndUsers = React.lazy(
  () => import('../../pages/RolesAndUsers/RolesAndUsers')
);
const TemplateCenter = React.lazy(
  () => import('../../pages/TemplateCenter/TemplateCenter')
);
const TaskGenerationLog = React.lazy(
  () => import('../../pages/TaskGenerationLog/TaskGenerationLog')
);
const NewTemplate = React.lazy(
  () => import('../../pages/TemplateCenter/CreateNewTemplate/NewTemplate')
);

export interface MainLink {
  url: string;
  title: LinkTitle;
  menuLabel?: LinkTitle;
  component: React.ComponentType<unknown>;
}

export const MainLinks: { [key in string]: MainLink } = {
  // Clients
  [LinkTitle.CreateNewClient]: {
    title: LinkTitle.CreateNewClient,
    url: '/create-new-client',
    component: CreateNewClient,
  },
  [LinkTitle.BulkEditClients]: {
    title: LinkTitle.BulkEditClients,
    url: '/bulk-edit-clients',
    component: () => <NotImplemented />,
  },
  [LinkTitle.MeetingCenter]: {
    title: LinkTitle.MeetingCenter,
    url: '/meeting-center',
    component: () => <NotImplemented />,
  },
  [LinkTitle.RecurringTasks]: {
    title: LinkTitle.RecurringTasks,
    url: '/recurring-tasks',
    component: () => <NotImplemented />,
  },
  [LinkTitle.ClientPlanning]: {
    title: LinkTitle.ClientPlanning,
    url: '/client-planning',
    component: () => <NotImplemented />,
  },

  // Filing
  [LinkTitle.FilingCenter]: {
    title: LinkTitle.FilingCenter,
    url: '/filing-center',
    component: () => <NotImplemented />,
  },
  [LinkTitle.ProcessScheduler]: {
    title: LinkTitle.ProcessScheduler,
    url: '/process-scheduler',
    component: () => <NotImplemented />,
  },
  [LinkTitle.EnterTargetDates]: {
    title: LinkTitle.EnterTargetDates,
    url: '/enter-target-dates',
    component: () => <NotImplemented />,
  },
  [LinkTitle.EnterPreviousPeriods]: {
    title: LinkTitle.EnterPreviousPeriods,
    url: '/enter-previous-periods',
    component: () => <NotImplemented />,
  },
  [LinkTitle.TaskAssignment]: {
    title: LinkTitle.TaskAssignment,
    url: '/task-assignment',
    component: () => <NotImplemented />,
  },
  [LinkTitle.ProjectAssignments]: {
    title: LinkTitle.ProjectAssignments,
    url: '/project-assignments',
    component: () => <NotImplemented />,
  },
  [LinkTitle.TaxPaymentCenter]: {
    title: LinkTitle.TaxPaymentCenter,
    url: '/tax-payment-center',
    component: () => <NotImplemented />,
  },

  // Billing
  [LinkTitle.BillingCenter]: {
    title: LinkTitle.BillingCenter,
    url: '/billing-center',
    component: () => <NotImplemented />,
  },
  [LinkTitle.NewInvoice]: {
    title: LinkTitle.NewInvoice,
    url: '/new-invoice',
    component: () => <NotImplemented />,
  },
  [LinkTitle.NewPayment]: {
    title: LinkTitle.NewPayment,
    url: '/new-payment',
    component: () => <NotImplemented />,
  },
  [LinkTitle.NewCharge]: {
    title: LinkTitle.NewCharge,
    url: '/new-charge',
    component: () => <NotImplemented />,
  },
  [LinkTitle.PaymentTask]: {
    title: LinkTitle.PaymentTask,
    url: '/payment-task',
    component: () => <NotImplemented />,
  },
  [LinkTitle.EnterPreviousPeriod]: {
    title: LinkTitle.EnterPreviousPeriod,
    url: '/enter-previous-period',
    component: () => <NotImplemented />,
  },
  [LinkTitle.RecurringItems]: {
    title: LinkTitle.RecurringItems,
    url: '/recurring-items',
    component: () => <NotImplemented />,
  },
  [LinkTitle.SalesCenter]: {
    title: LinkTitle.SalesCenter,
    url: '/sales-center',
    component: () => <NotImplemented />,
  },
  [LinkTitle.GeneralJournal]: {
    title: LinkTitle.GeneralJournal,
    url: '/general-journal',
    component: () => <NotImplemented />,
  },

  // Templates
  [LinkTitle.TemplateCenter]: {
    title: LinkTitle.TemplateCenter,
    url: '/template-center',
    component: () => <TemplateCenter />,
  },
  [LinkTitle.CreateNewTemplate]: {
    title: LinkTitle.CreateNewTemplate,
    url: CreateNewTemplateUrl,
    component: NewTemplate,
  },
  [LinkTitle.ManageLists]: {
    title: LinkTitle.ManageLists,
    url: '/manage-lists',
    component: AllLists,
  },

  // Worklog
  [LinkTitle.WorkLogCenter]: {
    title: LinkTitle.WorkLogCenter,
    url: '/work-log-center',
    component: () => <NotImplemented />,
  },
  [LinkTitle.NoteCenter]: {
    title: LinkTitle.NoteCenter,
    url: '/note-center',
    component: () => <NotImplemented />,
  },
  [LinkTitle.CallLogs]: {
    title: LinkTitle.CallLogs,
    url: '/call-logs',
    component: () => <NotImplemented />,
  },
  [LinkTitle.ProjectAuditTrail]: {
    title: LinkTitle.ProjectAuditTrail,
    url: '/project-audit-trail',
    component: () => <NotImplemented />,
  },
  [LinkTitle.CreditAuditTrail]: {
    title: LinkTitle.CreditAuditTrail,
    url: '/credit-audit-trail',
    component: () => <NotImplemented />,
  },

  // Staff
  [LinkTitle.ChartOfAccounts]: {
    title: LinkTitle.ChartOfAccounts,
    url: '/chart-of-accounts',
    component: () => <NotImplemented />,
  },
  [LinkTitle.PayCommission]: {
    title: LinkTitle.PayCommission,
    url: '/pay-commission',
    component: () => <NotImplemented />,
  },
  [LinkTitle.StaffCenter]: {
    title: LinkTitle.StaffCenter,
    url: '/staff-center',
    component: () => <NotImplemented />,
  },
  [LinkTitle.Settings]: {
    title: LinkTitle.Settings,
    url: '/settings',
    component: () => <NotImplemented />,
  },

  // Links
  [LinkTitle.WebPages]: {
    title: LinkTitle.WebPages,
    url: '/web-pages',
    component: () => <NotImplemented />,
  },

  // Administration
  [LinkTitle.RolesAndUsers]: {
    title: LinkTitle.RolesAndUsers,
    url: '/roles-and-users',
    component: RolesAndUsers,
  },
  [LinkTitle.TaskGenerationLog]: {
    title: LinkTitle.TaskGenerationLog,
    url: '/task-generation-log',
    component: TaskGenerationLog,
  },

  // Other
  [LinkTitle.Home]: {
    title: LinkTitle.Home,
    url: '/',
    component: HomePage,
  },
  [LinkTitle.Task]: {
    title: LinkTitle.Task,
    url: '/',
    component: HomePage,
  },
  [LinkTitle.Reminder]: {
    title: LinkTitle.Reminder,
    url: '/',
    component: HomePage,
  },
  [LinkTitle.Message]: {
    title: LinkTitle.Message,
    url: '/',
    component: HomePage,
  },
  [LinkTitle.Future]: {
    title: LinkTitle.Future,
    url: '/new-future',
    component: () => <NotImplemented />,
  },
  [LinkTitle.Charge]: {
    title: LinkTitle.Charge,
    url: '/charge',
    component: () => <NotImplemented />,
  },
  [LinkTitle.Payment]: {
    title: LinkTitle.Payment,
    url: '/new-payment',
    component: () => <NotImplemented />,
  },
  [LinkTitle.NewClient]: {
    title: LinkTitle.CreateNewClient,
    url: '/create-new-client',
    component: CreateNewClient,
  },
  [LinkTitle.EditClient]: {
    title: LinkTitle.EditClient,
    url: `${EditClientBaseUrl}/:id`,
    component: EditClient,
  },
  [LinkTitle.EditTemplate]: {
    title: LinkTitle.EditTemplate,
    url: `${EditTemplateBaseUrl}/:id`,
    component: EditTemplate,
  },
  [LinkTitle.EditTask]: {
    title: LinkTitle.EditTask,
    url: `${EditTaskBaseUrl}/:clientId/:id`,
    component: EditTask,
  },
  [LinkTitle.Client]: {
    title: LinkTitle.CreateNewClient,
    menuLabel: LinkTitle.Client,
    url: '/create-new-client',
    component: CreateNewClient,
  },
};

export const navigationLinks = [
  {
    title: 'Clients',
    links: [
      MainLinks[LinkTitle.CreateNewClient],
      MainLinks[LinkTitle.BulkEditClients],
      MainLinks[LinkTitle.MeetingCenter],
      MainLinks[LinkTitle.RecurringTasks],
      MainLinks[LinkTitle.ClientPlanning],
    ],
  },
  {
    title: 'Filing',
    links: [
      MainLinks[LinkTitle.FilingCenter],
      MainLinks[LinkTitle.ProcessScheduler],
      MainLinks[LinkTitle.EnterTargetDates],
      MainLinks[LinkTitle.EnterPreviousPeriods],
      MainLinks[LinkTitle.TaskAssignment],
      MainLinks[LinkTitle.ProjectAssignments],
      MainLinks[LinkTitle.TaxPaymentCenter],
    ],
  },
  {
    title: 'Billing',
    links: [
      MainLinks[LinkTitle.BillingCenter],
      MainLinks[LinkTitle.NewInvoice],
      MainLinks[LinkTitle.NewPayment],
      MainLinks[LinkTitle.NewCharge],
      MainLinks[LinkTitle.PaymentTask],
      MainLinks[LinkTitle.EnterPreviousPeriod],
      MainLinks[LinkTitle.RecurringItems],
      MainLinks[LinkTitle.SalesCenter],
      MainLinks[LinkTitle.GeneralJournal],
    ],
  },
  {
    title: 'Templates',
    links: [
      MainLinks[LinkTitle.TemplateCenter],
      MainLinks[LinkTitle.ManageLists],
    ],
  },
  {
    title: 'Worklog',
    links: [
      MainLinks[LinkTitle.WorkLogCenter],
      MainLinks[LinkTitle.NoteCenter],
      MainLinks[LinkTitle.CallLogs],
      MainLinks[LinkTitle.ProjectAuditTrail],
      MainLinks[LinkTitle.CreditAuditTrail],
    ],
  },
  {
    title: 'Staff',
    links: [
      MainLinks[LinkTitle.ChartOfAccounts],
      MainLinks[LinkTitle.PayCommission],
      MainLinks[LinkTitle.StaffCenter],
      MainLinks[LinkTitle.Settings],
    ],
  },
  {
    title: 'Links',
    links: [MainLinks[LinkTitle.WebPages]],
  },
  {
    title: 'Administration',
    links: [
      MainLinks[LinkTitle.RolesAndUsers],
      MainLinks[LinkTitle.TaskGenerationLog],
    ],
  },
] as const;

export const getLinkIcon = (link: MainLink): JSX.Element => {
  switch (link.title) {
    case LinkTitle.Task:
      return <NewTaskIcon />;
    case LinkTitle.Reminder:
      return <NewToDoIcon />;
    case LinkTitle.Message:
      return <NewMessageIcon />;
    case LinkTitle.Charge:
      return <NewChargeIcon />;
    case LinkTitle.Client:
      return <NewClientIcon />;
    case LinkTitle.Future:
      return <NewFutureIcon />;
    case LinkTitle.PaymentTask:
      return <PaymentTaskIcon />;
    case LinkTitle.NewInvoice:
      return <NewInvoiceIcon />;
    case LinkTitle.Payment:
      return <NewPaymentIcon />;
    default:
      return <NewTaskIcon />;
  }
};

export const menuItems = [
  MainLinks[LinkTitle.Task],
  MainLinks[LinkTitle.Reminder],
  MainLinks[LinkTitle.Message],
  MainLinks[LinkTitle.Charge],
  MainLinks[LinkTitle.PaymentTask],
  MainLinks[LinkTitle.Client],
  MainLinks[LinkTitle.NewInvoice],
  MainLinks[LinkTitle.Payment],
  MainLinks[LinkTitle.Future],
];
